import { useContext } from 'react';
import { useIntl } from 'react-intl';

import Poll from '@/components/polls/Poll';
import { PreSignupFlowContext } from '@/components/PreSignupFlow/PreSignupProvider';
import { useAnalytics } from '@/hooks/analytics';

import { getChoicesFromTiles, onSelectChoice } from '../utils';

interface Props {
	compact?: boolean;
}

const PollSingleClick = ({ compact }: Props) => {
	const { formatMessage } = useIntl();
	const { nextScreen, ActiveScreen } = useContext(PreSignupFlowContext);
	const { cta, questionType, tiles, question } = ActiveScreen;
	const { logEvent, logEventAsync } = useAnalytics();

	async function onComplete(choiceIds: string[]): Promise<void> {
		const choiceId = choiceIds[0];
		const selectedTile = tiles?.find(tile => tile.id === choiceId);
		if (!selectedTile) {
			return;
		}

		logEvent({
			eventName: 'FTUE : Intro Questions : Proceeded',
			eventProps: {
				choices: [choiceId],
				num_choices: 1,
				question_type: questionType as string,
			},
		});
		nextScreen();
	}

	return (
		<Poll
			key={questionType}
			title={question && formatMessage(question)}
			subtitle={cta && formatMessage(cta)}
			choices={getChoicesFromTiles(tiles, formatMessage)}
			onSelectChoice={(choiceId: string) => onSelectChoice(choiceId, questionType, logEventAsync)}
			onComplete={onComplete}
			compact={compact}
		/>
	);
};

export default PollSingleClick;
